import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { Macro } from './Macro';
import { AnswerMap } from '../AnswerMap';

export default class MacroResource extends FBaseService {
  public async getAll(): Promise<Macro[]> {
    const url = '/api/macro/';
    const response: AxiosResponse = await this.apiClient.get(url);
    return response.data.data;
  }

  public async get(name: string, includeReferences: boolean): Promise<Macro | null> {
    let url = `/api/macro/${name}`;

    if (includeReferences) {
      url += '?references=true';
    }

    try {
      const response: AxiosResponse = await this.apiClient.get(url);
      return response.data.data;
    } catch (error) {
      // Will 404 if macro does not exist.  Just return null.
      if (error.response.status !== 404) {
        throw error;
      } else {
        return null;
      }
    }
  }

  public async save(macro: Macro): Promise<Macro> {
    const url = '/api/macro/';

    const response: AxiosResponse = await this.apiClient.put(url, macro);
    return response.data.data;
  }

  public async delete(name: string): Promise<Macro> {
    const url = `/api/macro/${name}`;
    const response: AxiosResponse = await this.apiClient.delete(url);
    return response.data.data;
  }

  public async getPreview(macro: Macro, fiId: string, answers: AnswerMap, debug: boolean): Promise<string> {
    const url = `/api/macro/preview?debug=${debug}`;
    const response: AxiosResponse = await this.apiClient.post(url, { macro, answers, fiId });
    return response.data.data;
  }
}
